import { render, staticRenderFns } from "./goodsReport.vue?vue&type=template&id=36c5104b&scoped=true"
import script from "./goodsReport.vue?vue&type=script&lang=js"
export * from "./goodsReport.vue?vue&type=script&lang=js"
import style0 from "./goodsReport.vue?vue&type=style&index=0&id=36c5104b&prod&scoped=true&lang=css"
import style1 from "./goodsReport.vue?vue&type=style&index=1&id=36c5104b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c5104b",
  null
  
)

export default component.exports